import React, { useState } from 'react';
import { STATUSES, formatPhone, timeAgo } from './constants';

/**
 * A single incoming call. Drag it between columns to change status, or use the
 * inline selects to assign it to a staff member.
 */
export default function CallCard({ call, staff, onUpdate, onDragStart }) {
  const [open, setOpen] = useState(false);

  const assignee = staff.find((s) => s.id === call.assignee_id);

  return (
    <article
      className="call-card"
      draggable
      onDragStart={(e) => onDragStart(e, call.id)}
    >
      <header className="call-card-head">
        <div>
          <div className="call-caller">{call.caller_name || formatPhone(call.caller_number)}</div>
          {call.caller_name && (
            <div className="call-number">{formatPhone(call.caller_number)}</div>
          )}
        </div>
        <span className="call-time">{timeAgo(call.started_at || call.created_at)}</span>
      </header>

      {call.summary && (
        <p className={open ? 'call-summary' : 'call-summary clamp'}>{call.summary}</p>
      )}

      {(call.move_number || call.callback_number || call.preferred_callback_time) && (
        <div className="call-meta">
          {call.move_number && <span>Move {call.move_number}</span>}
          {call.callback_number && <span>☎ {formatPhone(call.callback_number)}</span>}
          {call.preferred_callback_time && <span>⏱ {call.preferred_callback_time}</span>}
        </div>
      )}

      <div className="call-tags">
        {assignee && (
          <span className="chip chip-assignee">
            {(assignee.full_name || assignee.email || '?').split(' ')[0]}
          </span>
        )}
      </div>

      {/* Controls: assign / tag / move */}
      <div className="call-controls">
        <select
          className="mini-select"
          value={call.assignee_id || ''}
          onChange={(e) => onUpdate(call.id, { assignee_id: e.target.value || null })}
          title="Assign to staff member"
        >
          <option value="">Unassigned</option>
          {staff.map((s) => (
            <option key={s.id} value={s.id}>
              {s.full_name || s.email}
            </option>
          ))}
        </select>

        <select
          className="mini-select"
          value={call.status}
          onChange={(e) => onUpdate(call.id, { status: e.target.value })}
          title="Move to status"
        >
          {STATUSES.map((s) => (
            <option key={s.key} value={s.key}>
              {s.label}
            </option>
          ))}
        </select>
      </div>

      {(call.transcript || call.recording_url) && (
        <button className="text-link call-expand" onClick={() => setOpen((v) => !v)}>
          {open ? 'Hide details' : 'View details'}
        </button>
      )}

      {open && (
        <div className="call-details">
          {call.recording_url && (
            <a href={call.recording_url} target="_blank" rel="noopener noreferrer" className="text-link">
              ▶ Recording
            </a>
          )}
          {call.transcript && <pre className="call-transcript">{call.transcript}</pre>}
        </div>
      )}
    </article>
  );
}
